import React from "react";
import { Grid } from "@mui/material";
import FormTextField from "../FormTextField";
import FileUploadField from "../FileUploadField";
import { useEmiAdminConfig } from "../../../hooks/useEmiAdminConfig";

const CibilCheckStep = ({ data, onChange, showErrors }) => {
  const { data: emiAdminConfig } = useEmiAdminConfig("v2");

  const fileError = (field) =>
    showErrors && !data[field] ? "This document is required" : "";

  const textError = (field) =>
    showErrors && !String(data[field] || "").trim()
      ? "This field is required"
      : "";

  const cibilError =
    data.cibilNumber &&
    emiAdminConfig?.minCIBIL &&
    Number(data.cibilNumber) < Number(emiAdminConfig.minCIBIL)
      ? `CIBIL Number must be at least ${emiAdminConfig.minCIBIL}`
      : textError("cibilNumber");

  return (
    <Grid container spacing={2.5}>
      <Grid item xs={12} sm={6}>
        <FileUploadField
          label="Aadhaar Card (Front)"
          required
          value={data.aadhaarFrontUrl}
          onChange={(file) => onChange("aadhaarFrontUrl", file)}
          error={fileError("aadhaarFrontUrl")}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <FileUploadField
          label="Aadhaar Card (Back)"
          required
          value={data.aadhaarBackUrl}
          onChange={(file) => onChange("aadhaarBackUrl", file)}
          error={fileError("aadhaarBackUrl")}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <FileUploadField
          label="PAN Card"
          required
          value={data.panCardUrl}
          onChange={(file) => onChange("panCardUrl", file)}
          error={fileError("panCardUrl")}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <FormTextField
          label="CIBIL Number"
          required
          value={data.cibilNumber}
          onChange={(value) => onChange("cibilNumber", value)}
          error={cibilError}
        />
      </Grid>
    </Grid>
  );
};

export default CibilCheckStep;
